export default {
  // 导航栏
  nav: {
    brand: 'DXF 查看器',
    docs: '博客'
  },
  
  // Hero区域
  hero: {
    badge: '专业 · 高效 · 现代',
    title: '下一代',
    titleHighlight: 'DXF查看器',
    description: '基于WebGL技术构建的现代化DXF文件预览工具，支持大文件快速渲染、图层控制、精确测量等专业功能。让CAD文件分享变得简单高效。',
    
    // 快速开始表单
    quickStart: {
      title: '立即开始',
      subtitle: '输入DXF文件URL开始预览',
      urlPlaceholder: 'https://example.com/your-file.dxf',
      titlePlaceholder: '自定义标题（可选）',
      showLayerLabel: '显示图层面板',
      showBackLabel: '显示后退按钮',
      submitButton: '开始预览'
    }
  },
  
  // 功能特性
  features: {
    title: '强大功能',
    subtitle: '专为现代工程师打造的DXF查看体验',
    
    fastLoading: {
      title: '快速加载',
      description: 'WebGL硬件加速，大文件秒开无等待'
    },
    layerControl: {
      title: '图层控制',
      description: '精确控制每个图层的显示和隐藏'
    },
    cloudAccess: {
      title: '云端访问',
      description: '无需安装，浏览器直接访问云端文件'
    },
    preciseMeasurement: {
      title: '精确测量',
      description: '内置测量工具，精确获取尺寸信息'
    },
    secureReliable: {
      title: '安全可靠',
      description: '本地处理，数据不上传服务器'
    },
    responsiveDesign: {
      title: '响应式设计',
      description: '完美适配桌面端和移动端设备'
    }
  },
  
  // API文档
  api: {
    title: '使用指南',
    subtitle: '通过URL参数快速访问和配置查看器',
    
    basic: {
      title: '基础查看器访问',
      example: '/viewer?dxfUrl=https://example.com/drawing.dxf'
    },
    showLayer: {
      title: '显示图层控制面板',
      example: '/viewer?dxfUrl=https://example.com/drawing.dxf&showLayer=true'
    },
    customTitle: {
      title: '自定义页面标题',
      example: '/viewer?dxfUrl=https://example.com/drawing.dxf&title=我的图纸'
    },
    showBack: {
      title: '隐藏后退按钮',
      example: '/viewer?dxfUrl=https://example.com/drawing.dxf&showBack=false'
    }
  },
  
  // 页脚
  footer: {
    brand: 'Fast DXF 查看器',
    docs: '博客',
    about: '关于',
    contact: '联系我们: fn9170@gmail.com',
    copyright: '© 2024 bytethink.dev. 保留所有权利。'
  },
  
  // DXF查看器组件
  dxfViewer: {
    loading: {
      font: '字体加载中 请稍后...',
      fetch: '文件下载中 请稍后...',
      parse: '文件解析中 请稍后...',
      prepare: '图纸加载中 请稍后...'
    },
    error: {
      occurred: '发生错误'
    }
  },

  // 常用词汇
  common: {
    example: '示例',
    get: 'GET',
    loading: '加载中...',
    error: '错误',
    success: '成功',
    language: '语言'
  },
  
  // SEO相关
  seo: {
    title: 'DXF查看器 - 专业在线DXF文件查看工具',
    description: '专业的在线DXF文件查看器，采用WebGL加速技术。在浏览器中查看CAD图纸，支持图层控制、测量工具、云端访问。无需安装，开箱即用。',
    keywords: 'DXF查看器, CAD查看器, 在线DXF, WebGL, 图纸查看器, 图层控制, 测量工具, 云端访问'
  },

  // 定价页面
  pricing: {
    nav: {
      home: '首页',
      pricing: '定价'
    },
    hero: {
      title: '企业级DXF解决方案',
      description: '通过我们的私有化部署解决方案，释放DXF查看的全部潜力。为您的组织提供增强的安全性、定制功能和专属支持。'
    },
    featured: '最受欢迎',
    plans: {
      free: {
        title: '免费在线版',
        period: '永久免费',
        features: [
          '在线DXF查看',
          '基础图层控制',
          'WebGL硬件加速',
          '社区支持',
          '无需注册'
        ],
        cta: '使用免费版'
      },
      enterprise: {
        title: '私有化部署',
        period: '一次性购买',
        features: [
          '完整Docker部署包',
          '自主托管部署',
          '数据不出本地网络',
          '自定义品牌选项',
          '高级安全功能',
          '优先邮件支持',
          '安装部署文档',
          '一年免费更新'
        ],
        cta: '立即购买'
      },
      custom: {
        title: '定制解决方案',
        price: '联系我们',
        features: [
          '定制功能开发',
          'API集成服务',
          '白标解决方案',
          '现场培训服务',
          '专属技术支持',
          '服务等级协议',
          '定制化部署',
          '维护服务合同'
        ],
        cta: '联系销售'
      }
    },
    features: {
      title: '为什么选择私有化部署？',
      private: {
        title: '完全数据隐私',
        description: '您的DXF文件永远不会离开您的网络。以完全的信心和合规性处理敏感的工程图纸。'
      },
      secure: {
        title: '企业级安全',
        description: '内置安全功能、用户认证和访问控制，满足您组织的安全要求。'
      },
      performance: {
        title: '优化性能',
        description: '部署在您自己的基础设施上，获得最大的性能和对资源及扩展的控制。'
      },
      support: {
        title: '专属支持',
        description: '获得我们团队的优先支持，保证响应时间并直接接触开发人员。'
      }
    },
    contact: {
      title: '准备开始了吗？',
      description: '对我们的企业解决方案有疑问？我们的团队在这里帮助您为您的组织找到完美的解决方案。',
      responseTime: '24小时响应时间',
      emailSubject: '企业级DXF查看器咨询',
      emailBody: '您好，我对DXF查看器的私有化部署选项很感兴趣。请提供以下相关信息：\n\n- 价格和许可\n- 技术要求\n- 实施时间表\n- 支持选项\n\n谢谢！',
      whatsappMessage: '您好！我对企业级DXF查看器-私有化部署解决方案很感兴趣。能否请您提供更多关于价格、技术要求和实施时间表的信息？谢谢！'
    },
    seo: {
      title: '企业级DXF查看器 - 私有化部署解决方案',
      description: '为您的组织获取DXF查看器的私有部署。基于Docker的解决方案，具有增强的安全性、定制功能和专属支持。',
      keywords: 'DXF查看器企业版, 私有化部署, Docker DXF查看器, CAD查看器托管, 自托管DXF, 企业CAD解决方案'
    }
  },

  // 博客页面
  blog: {
    title: '博客',
    subtitle: '关于DXF、CAD和工程工作流程的最新见解和教程',
    readMore: '阅读更多',
    backToBlog: '返回博客',
    publishedOn: '发布于',
    author: '作者',
    tags: '标签',
    relatedPosts: '相关文章',
    noPostsFound: '未找到博客文章。',
    searchPlaceholder: '搜索文章...',
    allCategories: '所有分类',
    seo: {
      title: 'DXF查看器博客 - CAD技巧、教程和行业见解',
      description: '发现关于DXF文件、CAD工作流程和工程最佳实践的最新技巧、教程和见解。',
      keywords: 'DXF博客, CAD教程, 工程技巧, DWG转DXF转换, CAD最佳实践'
    }
  }
}
